import { ITag } from '../../models/ITag';

export function isLastTag(tag: ITag) {
    return tag.message.toLowerCase() === 'last';
}
